import {
  Box,
  Button,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import React, { useState } from "react";

function BidModal({ open, handleClose, data, giveBid }) {
  const [value, setValue] = React.useState("");
  const [invalid, setInvalid] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "calc(100% - 28px)", sm: 430 },
    maxWidth: 430,
    boxSizing: "border-box",
    fontFamily: "Assistant",
    bgcolor: "#FFFFFF",
    border: "1px solid #E1ECF5",
    borderRadius: { xs: "22px", sm: "26px" },
    boxShadow: "0 28px 80px rgba(15, 45, 75, .22)",
    textAlign: "center",
    p: { xs: 2.5, sm: 3.5 },
    outline: "none",
  };

  const handleValueChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setValue(digitsOnly);
    if (invalid) setInvalid(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setInvalid(false);

    let data1 = new FormData(e.currentTarget);
    console.log(data1.get("bid"));
    if (data1.get("bid") > 10) {
      if (
        (parseInt(data1.get("bid")) >= data && parseInt(data) !== 0) ||
        parseInt(Math.abs(parseInt(data1.get("bid")) - data)) < 10
      ) {
        console.log(Math.abs(data1.get("bid")) - data);
        setInvalid(true);
      } else {
        handleClose();
        giveBid(data1.get("bid"));
      }
    } else setInvalid(true);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{
        sx: { backgroundColor: "rgba(15, 35, 55, .42)", backdropFilter: "blur(3px)" },
      }}
    >
      <Box className="bidit-bid-modal" sx={style} dir="rtl">
        <Button
          onClick={handleClose}
          aria-label="סגור"
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            minWidth: 38,
            width: 38,
            height: 38,
            borderRadius: "50%",
            color: "#64748B",
            backgroundColor: "#F5F8FB",
            "&:hover": { backgroundColor: "#EAF1F7" },
          }}
        >
          <CloseRoundedIcon fontSize="small" />
        </Button>

        <Box
          sx={{
            width: 58,
            height: 58,
            mx: "auto",
            mb: 1.5,
            borderRadius: "18px",
            display: "grid",
            placeItems: "center",
            background: "linear-gradient(135deg, #EAF5FF 0%, #F4FAFF 100%)",
            color: "#1677C8",
            border: "1px solid #D7EAFE",
          }}
        >
          <GavelRoundedIcon sx={{ fontSize: 30 }} />
        </Box>

        <Typography
          id="modal-modal-title"
          variant="h5"
          component="h2"
          sx={{
            fontFamily: "Assistant",
            fontWeight: 800,
            color: "#17324D",
            letterSpacing: "-.02em",
            mb: 0.75,
          }}
        >
          תן את ההצעה שלך
        </Typography>

        <Typography
          id="modal-modal-description"
          sx={{
            fontFamily: "Assistant",
            color: "#64748B",
            lineHeight: 1.65,
            fontSize: "15.5px",
          }}
        >
          {data.toString() === "0"
            ? "מה המחיר הטוב ביותר שתוכל להציע עבור המכרז?"
            : `ההצעה הנמוכה ביותר כרגע היא ${data} ש״ח. כדי להתקדם בדירוג יש להציע מחיר נמוך יותר.`}
        </Typography>

        <Stack
          component="form"
          onSubmit={handleSubmit}
          sx={{ mt: 3, gap: 1.5, fontFamily: "Assistant" }}
        >
          <TextField
            id="bid"
            name="bid"
            value={value}
            onChange={handleValueChange}
            autoFocus
            fullWidth
            placeholder="לדוגמה: 450"
            variant="outlined"
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              autoComplete: "off",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, color: "#47627A" }}>
                    ₪
                  </Typography>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 58,
                borderRadius: "15px",
                backgroundColor: "#FBFDFF",
                fontFamily: "Assistant",
                fontSize: "19px",
                fontWeight: 800,
                "& fieldset": { borderColor: invalid ? "#E05252" : "#D6E4EF" },
                "&:hover fieldset": { borderColor: invalid ? "#E05252" : "#9FC7E8" },
                "&.Mui-focused fieldset": { borderColor: invalid ? "#E05252" : "#1677C8" },
              },
              "& input": { textAlign: "center", direction: "ltr" },
            }}
          />

          {invalid && (
            <Typography
              role="alert"
              sx={{
                fontFamily: "Assistant",
                color: "#B42318",
                backgroundColor: "#FFF4F3",
                border: "1px solid #FFD5D2",
                borderRadius: "12px",
                px: 1.5,
                py: 1,
                fontSize: "14px",
              }}
            >
              {data === 0
                ? "יש להזין הצעה של 11 ש״ח לפחות."
                : `יש להזין הצעה הנמוכה לפחות ב-10 ש״ח מההצעה הנוכחית (${data} ש״ח).`}
            </Typography>
          )}

          <Button
            variant="contained"
            type="submit"
            disabled={!value}
            sx={{
              minHeight: 52,
              mt: 0.5,
              borderRadius: "14px",
              fontFamily: "Assistant",
              fontWeight: 800,
              fontSize: "16px",
              textTransform: "none",
              background: "linear-gradient(135deg, #1677C8 0%, #3399FF 100%)",
              boxShadow: "0 10px 24px rgba(22,119,200,.22)",
              "&:hover": {
                background: "linear-gradient(135deg, #126BB7 0%, #238BEF 100%)",
                boxShadow: "0 13px 28px rgba(22,119,200,.28)",
              },
            }}
          >
            שלח הצעה
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default BidModal;
